// @generated by protoc-gen-es v2.6.2 with parameter "target=ts"
// @generated from file bff/v1/model.proto (package bff.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bff/v1/model.proto.
 */
export const file_bff_v1_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * プロダクトのモデル
 *
 * @generated from message bff.v1.Product
 */
export type Product = Message<"bff.v1.Product"> & {
  /**
   * プロダクトID
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * プロダクト名
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * プロダクトのTOPページURL
   *
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * ユーザー表示フラグ、これがtrueであればeCloudなどでユーザー向けに表示される
   *
   * @generated from field: bool is_public = 4;
   */
  isPublic: boolean;

  /**
   * 表示順序
   *
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;
};

/**
 * Describes the message bff.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 0);

/**
 * メンバーのモデル
 *
 * @generated from message bff.v1.Member
 */
export type Member = Message<"bff.v1.Member"> & {
  /**
   * メンバーID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 所属している企業のID
   *
   * @generated from field: string company_id = 2;
   */
  companyId: string;

  /**
   * 所属している企業名
   *
   * @generated from field: string company_name = 3;
   */
  companyName: string;

  /**
   * 所属している組織のID
   *
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * 所属している組織名
   *
   * @generated from field: string organization_name = 5;
   */
  organizationName: string;

  /**
   * メンバー名
   *
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * メールアドレス
   *
   * @generated from field: string email = 7;
   */
  email: string;

  /**
   * 電話番号
   *
   * @generated from field: string phone_number = 8;
   */
  phoneNumber: string;

  /**
   * 携帯番号
   *
   * @generated from field: string mobile_number = 9;
   */
  mobileNumber: string;

  /**
   * プロフィール画像のURL
   *
   * @generated from field: string image_url = 10;
   */
  imageUrl: string;

  /**
   * 役割
   *
   * @generated from field: bff.v1.MemberRole role = 11;
   */
  role: MemberRole;

  /**
   * ステータス
   *
   * @generated from field: bff.v1.MemberStatus status = 12;
   */
  status: MemberStatus;

  /**
   * plan_codeをキーにしたユーザーロール設定のマップ
   *
   * @generated from field: bff.v1.UserRoleSettingMap user_role_map = 13;
   */
  userRoleMap?: UserRoleSettingMap;

  /**
   * plan_codeをキーにした現在有効なベースライセンスのマップ
   *
   * @generated from field: map<string, bff.v1.License> base_license_map = 14;
   */
  baseLicenseMap: { [key: string]: License };

  /**
   * plan_codeをキーにした現在有効なオプションライセンスのマップ
   *
   * @generated from field: map<string, bff.v1.License> option_license_map = 15;
   */
  optionLicenseMap: { [key: string]: License };

  /**
   * 言語設定
   *
   * @generated from field: bff.v1.Language language = 16;
   */
  language: Language;

  /**
   * ユーザーロールコードのリスト
   *
   * @generated from field: repeated string user_role_codes = 17;
   */
  userRoleCodes: string[];

  /**
   * 作成日時
   *
   * @generated from field: bff.v1.Date createdAt = 18;
   */
  createdAt?: Date;

  /**
   * メンバー名(英語表記)
   *
   * @generated from field: string english_name = 19;
   */
  englishName: string;

  /**
   * MFA設定済みフラグ
   *
   * @generated from field: optional bool mfa_enabled = 20;
   */
  mfaEnabled?: boolean;

  /**
   * IPアドレスによる認証の試行がロックされているかどうか
   *
   * @generated from field: bool is_ip_locked = 21;
   */
  isIpLocked: boolean;

  /**
   * 二要素認証の試行がロックされているかどうか
   *
   * @generated from field: bool is_mfa_locked = 22;
   */
  isMfaLocked: boolean;
};

/**
 * Describes the message bff.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 1);

/**
 * セッションの情報
 *
 * @generated from message bff.v1.SessionInformation
 */
export type SessionInformation = Message<"bff.v1.SessionInformation"> & {
  /**
   * セッションキー
   *
   * @generated from field: string session_key = 1;
   */
  sessionKey: string;

  /**
   * デバイス
   *
   * @generated from field: string platform = 2;
   */
  platform: string;

  /**
   * ブラウザー
   *
   * @generated from field: string browser = 3;
   */
  browser: string;

  /**
   * ログイン時刻
   *
   * @generated from field: google.protobuf.Timestamp login_at = 4;
   */
  loginAt?: Timestamp;

  /**
   * 現在のセッションかどうか
   *
   * @generated from field: bool current = 5;
   */
  current: boolean;
};

/**
 * Describes the message bff.v1.SessionInformation.
 * Use `create(SessionInformationSchema)` to create a new message.
 */
export const SessionInformationSchema: GenMessage<SessionInformation> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 2);

/**
 * ライセンスのモデル
 *
 * @generated from message bff.v1.License
 */
export type License = Message<"bff.v1.License"> & {
  /**
   * 契約プランID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * プロダクト名
   *
   * @generated from field: string product_name = 2;
   */
  productName: string;

  /**
   * プランID
   *
   * @generated from field: int32 plan_id = 3;
   */
  planId: number;

  /**
   * プラン種別
   *
   * @generated from field: bff.v1.PlanType plan_type = 4;
   */
  planType: PlanType;

  /**
   * プランコード
   *
   * @generated from field: string plan_code = 5;
   */
  planCode: string;

  /**
   * プラン名
   *
   * @generated from field: string plan_name = 6;
   */
  planName: string;

  /**
   * プラン名(英語)
   *
   * @generated from field: string eng_plan_name = 7;
   */
  engPlanName: string;

  /**
   * 開始日
   *
   * @generated from field: bff.v1.Date start_date = 8;
   */
  startDate?: Date;

  /**
   * 終了日
   *
   * @generated from field: bff.v1.Date end_date = 9;
   */
  endDate?: Date;

  /**
   * 契約タイプ
   *
   * @generated from field: bff.v1.LicenseContractType contract_type = 10;
   */
  contractType: LicenseContractType;

  /**
   * ライセンスステータス
   *
   * @generated from field: bff.v1.LicenseStatus status = 11;
   */
  status: LicenseStatus;

  /**
   * ユーザーがユーザーロール設定可能かどうか
   *
   * @generated from field: bool is_user_role_configurable = 12;
   */
  isUserRoleConfigurable: boolean;

  /**
   * ユーザーへ表示可能なプロダクトかどうか
   *
   * @generated from field: bool is_product_public = 13;
   */
  isProductPublic: boolean;
};

/**
 * Describes the message bff.v1.License.
 * Use `create(LicenseSchema)` to create a new message.
 */
export const LicenseSchema: GenMessage<License> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 3);

/**
 * プラン毎に設定できるユーザーロールのモデル
 *
 * @generated from message bff.v1.UserRole
 */
export type UserRole = Message<"bff.v1.UserRole"> & {
  /**
   * ユーザーロールID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ユーザーロール識別用コード
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * ユーザーロール名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * ユーザーロール名(英語)
   *
   * @generated from field: string eng_name = 4;
   */
  engName: string;

  /**
   * 有効・無効
   *
   * @generated from field: bff.v1.UserRoleStatus status = 5;
   */
  status: UserRoleStatus;

  /**
   * ユーザーロールの説明用メモ
   *
   * @generated from field: string memo = 6;
   */
  memo: string;

  /**
   * ユーザーロールの説明用メモ(英語)
   *
   * @generated from field: string eng_memo = 7;
   */
  engMemo: string;

  /**
   * デフォルトのユーザーロールかどうか
   *
   * @generated from field: bool is_default = 8;
   */
  isDefault: boolean;

  /**
   * マスターのユーザーロールかどうか
   *
   * @generated from field: bool is_master = 9;
   */
  isMaster: boolean;
};

/**
 * Describes the message bff.v1.UserRole.
 * Use `create(UserRoleSchema)` to create a new message.
 */
export const UserRoleSchema: GenMessage<UserRole> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 4);

/**
 * ユーザーロールのリスト
 *
 * @generated from message bff.v1.UserRoles
 */
export type UserRoles = Message<"bff.v1.UserRoles"> & {
  /**
   * ユーザーロール
   *
   * @generated from field: repeated bff.v1.UserRole user_roles = 1;
   */
  userRoles: UserRole[];
};

/**
 * Describes the message bff.v1.UserRoles.
 * Use `create(UserRolesSchema)` to create a new message.
 */
export const UserRolesSchema: GenMessage<UserRoles> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 5);

/**
 * 日付のモデル
 *
 * @generated from message bff.v1.Date
 */
export type Date = Message<"bff.v1.Date"> & {
  /**
   * 年
   *
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * 月
   *
   * @generated from field: uint32 month = 2;
   */
  month: number;

  /**
   * 日
   *
   * @generated from field: uint32 day = 3;
   */
  day: number;
};

/**
 * Describes the message bff.v1.Date.
 * Use `create(DateSchema)` to create a new message.
 */
export const DateSchema: GenMessage<Date> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 6);

/**
 * @generated from message bff.v1.UserRoleSettingMap
 */
export type UserRoleSettingMap = Message<"bff.v1.UserRoleSettingMap"> & {
  /**
   * plan_codeをキーにしたユーザーロール設定マップ
   *
   * @generated from field: map<string, bff.v1.UserRoleSettings> setting_map = 1;
   */
  settingMap: { [key: string]: UserRoleSettings };
};

/**
 * Describes the message bff.v1.UserRoleSettingMap.
 * Use `create(UserRoleSettingMapSchema)` to create a new message.
 */
export const UserRoleSettingMapSchema: GenMessage<UserRoleSettingMap> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 7);

/**
 * @generated from message bff.v1.UserRoleSettings
 */
export type UserRoleSettings = Message<"bff.v1.UserRoleSettings"> & {
  /**
   * ユーザーロール設定
   *
   * @generated from field: repeated bff.v1.UserRoleSetting settings = 1;
   */
  settings: UserRoleSetting[];
};

/**
 * Describes the message bff.v1.UserRoleSettings.
 * Use `create(UserRoleSettingsSchema)` to create a new message.
 */
export const UserRoleSettingsSchema: GenMessage<UserRoleSettings> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 8);

/**
 * ユーザーロール設定のモデル
 *
 * @generated from message bff.v1.UserRoleSetting
 */
export type UserRoleSetting = Message<"bff.v1.UserRoleSetting"> & {
  /**
   * ユーザーロールID
   *
   * @generated from field: string user_role_id = 1;
   */
  userRoleId: string;

  /**
   * ユーザーロールコード
   *
   * @generated from field: string user_role_code = 2;
   */
  userRoleCode: string;

  /**
   * ユーザーロール名
   *
   * @generated from field: string user_role_name = 3;
   */
  userRoleName: string;

  /**
   * ユーザーロール名(英語)
   *
   * @generated from field: string user_role_eng_name = 4;
   */
  userRoleEngName: string;

  /**
   * ユーザーロールの説明用メモ
   *
   * @generated from field: string user_role_memo = 5;
   */
  userRoleMemo: string;

  /**
   * ユーザーロールの説明用メモ(英語)
   *
   * @generated from field: string user_role_eng_memo = 6;
   */
  userRoleEngMemo: string;

  /**
   * デフォルトのユーザーロールかどうか
   *
   * @generated from field: bool is_default = 7;
   */
  isDefault: boolean;

  /**
   * マスターのユーザーロールかどうか
   *
   * @generated from field: bool is_master = 8;
   */
  isMaster: boolean;

  /**
   * ユーザーロールが設定されているかどうか
   *
   * @generated from field: bool is_setting = 9;
   */
  isSetting: boolean;
};

/**
 * Describes the message bff.v1.UserRoleSetting.
 * Use `create(UserRoleSettingSchema)` to create a new message.
 */
export const UserRoleSettingSchema: GenMessage<UserRoleSetting> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 9);

/**
 * 組織のモデル
 *
 * @generated from message bff.v1.Organization
 */
export type Organization = Message<"bff.v1.Organization"> & {
  /**
   * 組織ID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 所属している企業のID
   *
   * @generated from field: string company_id = 2;
   */
  companyId: string;

  /**
   * 企業名
   *
   * @generated from field: string company_name = 3;
   */
  companyName: string;

  /**
   * 企業名(英語)
   *
   * @generated from field: string company_eng_name = 4;
   */
  companyEngName: string;

  /**
   * 組織名
   *
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * 組織名(英語)
   *
   * @generated from field: string eng_name = 6;
   */
  engName: string;

  /**
   * 略称
   *
   * @generated from field: string abbreviation = 7;
   */
  abbreviation: string;

  /**
   * ロゴ画像のURL
   *
   * @generated from field: string image_url = 8;
   */
  imageUrl: string;

  /**
   * 作成日時
   *
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * 更新日時
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bff.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 10);

/**
 * プランのモデル
 *
 * @generated from message bff.v1.Plan
 */
export type Plan = Message<"bff.v1.Plan"> & {
  /**
   * プランID
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * プランコード
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * プラン名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * プラン名(英語)
   *
   * @generated from field: string eng_name = 4;
   */
  engName: string;

  /**
   * プラン種別
   *
   * @generated from field: bff.v1.PlanType type = 5;
   */
  type: PlanType;
};

/**
 * Describes the message bff.v1.Plan.
 * Use `create(PlanSchema)` to create a new message.
 */
export const PlanSchema: GenMessage<Plan> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 11);

/**
 * 利用規約への同意モデル
 *
 * @generated from message bff.v1.Term
 */
export type Term = Message<"bff.v1.Term"> & {
  /**
   * 規約名
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 規約バージョンID
   *
   * @generated from field: int32 versionId = 2;
   */
  versionId: number;

  /**
   * 規約バージョン
   *
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * 規約URL
   *
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * ライセンスID
   *
   * @generated from field: string license_id = 5;
   */
  licenseId: string;

  /**
   * 同意ステータス
   *
   * @generated from field: bff.v1.TermAgreementStatus status = 6;
   */
  status: TermAgreementStatus;
};

/**
 * Describes the message bff.v1.Term.
 * Use `create(TermSchema)` to create a new message.
 */
export const TermSchema: GenMessage<Term> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 12);

/**
 * 請求書送付先のモデル
 *
 * @generated from message bff.v1.BillingEmail
 */
export type BillingEmail = Message<"bff.v1.BillingEmail"> & {
  /**
   * 組織ID
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * メールアドレス
   *
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];

  /**
   * 更新したメンバー名
   *
   * @generated from field: optional string updated_by = 3;
   */
  updatedBy?: string;

  /**
   * プロダクトID (0/未設定は全体送付先)
   *
   * @generated from field: optional int32 product_id = 4;
   */
  productId?: number;

  /**
   * プロダクト名
   *
   * @generated from field: optional string product_name = 5;
   */
  productName?: string;

  /**
   * 全体送付先かどうか (product_id=0)
   *
   * @generated from field: optional bool is_general = 6;
   */
  isGeneral?: boolean;

  /**
   * 更新したメンバーの所属組織名
   *
   * @generated from field: optional string updated_by_org = 7;
   */
  updatedByOrg?: string;

  /**
   * 更新日時
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * 更新したメンバー名(英語)。未設定の場合は空
   *
   * @generated from field: optional string updated_by_eng_name = 9;
   */
  updatedByEngName?: string;

  /**
   * 更新したメンバーの所属組織名(英語)。未設定の場合は空
   *
   * @generated from field: optional string updated_by_org_eng_name = 10;
   */
  updatedByOrgEngName?: string;

  /**
   * enechain運用側の更新かどうか
   *
   * @generated from field: optional bool is_updated_by_enechain_operation = 11;
   */
  isUpdatedByEnechainOperation?: boolean;

  /**
   * 請求書の宛名。プロダクト個別送付先のみで使い、空文字の場合は組織名が使われる
   *
   * @generated from field: optional string display_name = 12;
   */
  displayName?: string;
};

/**
 * Describes the message bff.v1.BillingEmail.
 * Use `create(BillingEmailSchema)` to create a new message.
 */
export const BillingEmailSchema: GenMessage<BillingEmail> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 13);

/**
 * 企業の許可ドメインのモデル
 *
 * @generated from message bff.v1.CompanyAllowedMailDomain
 */
export type CompanyAllowedMailDomain = Message<"bff.v1.CompanyAllowedMailDomain"> & {
  /**
   * メールドメイン設定ID
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * メールアドレスドメイン部
   *
   * @generated from field: repeated string domains = 2;
   */
  domains: string[];
};

/**
 * Describes the message bff.v1.CompanyAllowedMailDomain.
 * Use `create(CompanyAllowedMailDomainSchema)` to create a new message.
 */
export const CompanyAllowedMailDomainSchema: GenMessage<CompanyAllowedMailDomain> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 14);

/**
 * 新基盤(M2M)APIキーのモデル(rawキーは含まない)
 *
 * @generated from message bff.v1.ApiKey
 */
export type ApiKey = Message<"bff.v1.ApiKey"> & {
  /**
   * APIキーID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * APIキー名
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * キープレフィックス(識別用)
   *
   * @generated from field: string key_prefix = 3;
   */
  keyPrefix: string;

  /**
   * ステータス(revoked_at/expires_atから導出)
   *
   * @generated from field: bff.v1.ApiKeyStatus status = 4;
   */
  status: ApiKeyStatus;

  /**
   * 付与されたロール名
   *
   * @generated from field: repeated string role_names = 5;
   */
  roleNames: string[];

  /**
   * 作成日時
   *
   * @generated from field: optional google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * 有効期限(未設定 = 無期限)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp;

  /**
   * 最終使用日時(未設定 = 未使用)
   *
   * @generated from field: optional google.protobuf.Timestamp last_used_at = 8;
   */
  lastUsedAt?: Timestamp;

  /**
   * 失効日時
   *
   * @generated from field: optional google.protobuf.Timestamp revoked_at = 9;
   */
  revokedAt?: Timestamp;
};

/**
 * Describes the message bff.v1.ApiKey.
 * Use `create(ApiKeySchema)` to create a new message.
 */
export const ApiKeySchema: GenMessage<ApiKey> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 15);

/**
 * 新基盤(M2M)APIキーに付与できるパーミッションのモデル
 *
 * @generated from message bff.v1.ApiKeyPermission
 */
export type ApiKeyPermission = Message<"bff.v1.ApiKeyPermission"> & {
  /**
   * パーミッション名(例: "trading.sell.write")
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 概要
   *
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message bff.v1.ApiKeyPermission.
 * Use `create(ApiKeyPermissionSchema)` to create a new message.
 */
export const ApiKeyPermissionSchema: GenMessage<ApiKeyPermission> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 16);

/**
 * 新基盤(M2M)APIキーで呼び出せるHTTPエンドポイントの表示用情報のモデル
 * eauthのカタログにはエンドポイント専用の説明が無いため、description には紐づくパーミッションの説明を入れる(空になりうる)
 *
 * @generated from message bff.v1.ApiKeyEndpointMetadata
 */
export type ApiKeyEndpointMetadata = Message<"bff.v1.ApiKeyEndpointMetadata"> & {
  /**
   * HTTPメソッド(例: "GET", "POST")
   *
   * @generated from field: string method = 1;
   */
  method: string;

  /**
   * パス(例: "/v1/orders/sell")
   *
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * 用途(紐づくパーミッションの説明を転用)
   *
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message bff.v1.ApiKeyEndpointMetadata.
 * Use `create(ApiKeyEndpointMetadataSchema)` to create a new message.
 */
export const ApiKeyEndpointMetadataSchema: GenMessage<ApiKeyEndpointMetadata> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 17);

/**
 * 新基盤(M2M)APIキーに付与できるロールのモデル
 *
 * @generated from message bff.v1.ApiKeyRole
 */
export type ApiKeyRole = Message<"bff.v1.ApiKeyRole"> & {
  /**
   * ロール名(例: "trading.admin")
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * ロールID(UUID)
   *
   * @generated from field: string id = 6;
   */
  id: string;

  /**
   * 所属スコープ名
   *
   * @generated from field: string scope_name = 2;
   */
  scopeName: string;

  /**
   * 概要
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 紐づくパーミッション
   *
   * @generated from field: repeated bff.v1.ApiKeyPermission permissions = 4;
   */
  permissions: ApiKeyPermission[];

  /**
   * 呼び出せるエンドポイント(method+pathで重複排除済み・カタログ順)
   *
   * @generated from field: repeated bff.v1.ApiKeyEndpointMetadata endpoints = 5;
   */
  endpoints: ApiKeyEndpointMetadata[];
};

/**
 * Describes the message bff.v1.ApiKeyRole.
 * Use `create(ApiKeyRoleSchema)` to create a new message.
 */
export const ApiKeyRoleSchema: GenMessage<ApiKeyRole> = /*@__PURE__*/
  messageDesc(file_bff_v1_model, 18);

/**
 * @generated from enum bff.v1.EmailVerifiedStatus
 */
export enum EmailVerifiedStatus {
  /**
   * @generated from enum value: EMAIL_VERIFIED_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: EMAIL_VERIFIED_STATUS_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: EMAIL_VERIFIED_STATUS_ALREADY_VERIFIED = 2;
   */
  ALREADY_VERIFIED = 2,

  /**
   * @generated from enum value: EMAIL_VERIFIED_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum bff.v1.EmailVerifiedStatus.
 */
export const EmailVerifiedStatusSchema: GenEnum<EmailVerifiedStatus> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 0);

/**
 * ユーザーロールステータスのモデル
 *
 * @generated from enum bff.v1.UserRoleStatus
 */
export enum UserRoleStatus {
  /**
   * 不明
   *
   * @generated from enum value: USER_ROLE_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 有効
   *
   * @generated from enum value: USER_ROLE_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * 無効
   *
   * @generated from enum value: USER_ROLE_STATUS_INACTIVE = 2;
   */
  INACTIVE = 2,
}

/**
 * Describes the enum bff.v1.UserRoleStatus.
 */
export const UserRoleStatusSchema: GenEnum<UserRoleStatus> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 1);

/**
 * メンバーの役割のモデル
 *
 * @generated from enum bff.v1.MemberRole
 */
export enum MemberRole {
  /**
   * 不明
   *
   * @generated from enum value: MEMBER_ROLE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 管理者
   *
   * @generated from enum value: MEMBER_ROLE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * メンバー
   *
   * @generated from enum value: MEMBER_ROLE_MEMBER = 2;
   */
  MEMBER = 2,
}

/**
 * Describes the enum bff.v1.MemberRole.
 */
export const MemberRoleSchema: GenEnum<MemberRole> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 2);

/**
 * メンバーの状態のモデル
 *
 * @generated from enum bff.v1.MemberStatus
 */
export enum MemberStatus {
  /**
   * 不明
   *
   * @generated from enum value: MEMBER_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 招待中
   *
   * @generated from enum value: MEMBER_STATUS_INVITED = 1;
   */
  INVITED = 1,

  /**
   * アクティブ
   *
   * @generated from enum value: MEMBER_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * 削除済み
   *
   * @generated from enum value: MEMBER_STATUS_DELETED = 3;
   */
  DELETED = 3,

  /**
   * 一時停止（管理者による強制ロックアウト）
   *
   * @generated from enum value: MEMBER_STATUS_SUSPENDED = 4;
   */
  SUSPENDED = 4,
}

/**
 * Describes the enum bff.v1.MemberStatus.
 */
export const MemberStatusSchema: GenEnum<MemberStatus> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 3);

/**
 * プラン種別のモデル
 *
 * @generated from enum bff.v1.PlanType
 */
export enum PlanType {
  /**
   * 不明
   *
   * @generated from enum value: PLAN_TYPE_UNKNOWN = 0;
   */
  PLAN_TYPE_UNKNOWN = 0,

  /**
   * ベース
   *
   * @generated from enum value: BASE = 1;
   */
  BASE = 1,

  /**
   * オプション
   *
   * @generated from enum value: OPTION = 2;
   */
  OPTION = 2,
}

/**
 * Describes the enum bff.v1.PlanType.
 */
export const PlanTypeSchema: GenEnum<PlanType> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 4);

/**
 * ライセンス契約モデル
 *
 * @generated from enum bff.v1.LicenseContractType
 */
export enum LicenseContractType {
  /**
   * 不明
   *
   * @generated from enum value: CONTRACT_TYPE_UNKNOWN = 0;
   */
  CONTRACT_TYPE_UNKNOWN = 0,

  /**
   * 固定期間契約
   *
   * @generated from enum value: TERM = 1;
   */
  TERM = 1,

  /**
   * 無期限契約
   *
   * @generated from enum value: EVERGREEN = 2;
   */
  EVERGREEN = 2,
}

/**
 * Describes the enum bff.v1.LicenseContractType.
 */
export const LicenseContractTypeSchema: GenEnum<LicenseContractType> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 5);

/**
 * ライセンスのステータスのモデル
 *
 * @generated from enum bff.v1.LicenseStatus
 */
export enum LicenseStatus {
  /**
   * 不明
   *
   * @generated from enum value: LICENSE_STATUS_UNKNOWN = 0;
   */
  LICENSE_STATUS_UNKNOWN = 0,

  /**
   * アクティブ
   *
   * @generated from enum value: LICENSE_ACTIVE = 1;
   */
  LICENSE_ACTIVE = 1,

  /**
   * 有効期限切れ
   *
   * @generated from enum value: LICENSE_TERMINATED = 2;
   */
  LICENSE_TERMINATED = 2,

  /**
   * 未来に有効になる
   *
   * @generated from enum value: LICENSE_EFFECTIVE_IN_FUTURE = 3;
   */
  LICENSE_EFFECTIVE_IN_FUTURE = 3,
}

/**
 * Describes the enum bff.v1.LicenseStatus.
 */
export const LicenseStatusSchema: GenEnum<LicenseStatus> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 6);

/**
 * 言語のモデル
 *
 * @generated from enum bff.v1.Language
 */
export enum Language {
  /**
   * 不明
   *
   * @generated from enum value: LANGUAGE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 日本語
   *
   * @generated from enum value: Language_JAPANESE = 1;
   */
  JAPANESE = 1,

  /**
   * 英語
   *
   * @generated from enum value: Language_ENGLISH = 2;
   */
  ENGLISH = 2,
}

/**
 * Describes the enum bff.v1.Language.
 */
export const LanguageSchema: GenEnum<Language> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 7);

/**
 * 規約の同意ステータス
 *
 * @generated from enum bff.v1.TermAgreementStatus
 */
export enum TermAgreementStatus {
  /**
   * 不明
   *
   * @generated from enum value: TERM_AGREEMENT_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 同意済み
   *
   * @generated from enum value: TERM_AGREEMENT_STATUS_AGREED = 1;
   */
  AGREED = 1,

  /**
   * 同意前
   *
   * @generated from enum value: TERM_AGREEMENT_STATUS_PENDING = 2;
   */
  PENDING = 2,
}

/**
 * Describes the enum bff.v1.TermAgreementStatus.
 */
export const TermAgreementStatusSchema: GenEnum<TermAgreementStatus> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 8);

/**
 * 新基盤(M2M)APIキーのステータスのモデル
 *
 * @generated from enum bff.v1.ApiKeyStatus
 */
export enum ApiKeyStatus {
  /**
   * 不明
   *
   * @generated from enum value: API_KEY_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 有効
   *
   * @generated from enum value: API_KEY_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * 無効(失効済み・期限切れ)
   *
   * @generated from enum value: API_KEY_STATUS_INACTIVE = 2;
   */
  INACTIVE = 2,
}

/**
 * Describes the enum bff.v1.ApiKeyStatus.
 */
export const ApiKeyStatusSchema: GenEnum<ApiKeyStatus> = /*@__PURE__*/
  enumDesc(file_bff_v1_model, 9);

